// Curb Crew retail pricing config.
// Adjust these once final hardware/postage costing is locked in — every page updates automatically.

export const PRICING = {
  pack_size: 2,
  pack_price: 99,
  pack_cards_resold: 2,

  cardholder_price: 99,

  hardware_cost_per_card: 15,

  shipping_fee: 110,
  free_shipping_threshold: 20,

  currency_symbol: "R",
};

export const curbMarginPerCard = () =>
  Math.round(
    (PRICING.pack_price - PRICING.hardware_cost_per_card * PRICING.pack_size) /
      PRICING.pack_size
  );

export const fmtR = (n) => `${PRICING.currency_symbol}${Math.round(n).toLocaleString("en-ZA")}`;
